import {
  createFileRoute,
  Outlet,
  retainSearchParams,
} from '@tanstack/react-router';
import { z } from 'zod';

const searchSchema = z.object({
  sampleSetSearch: z.string().optional(),
});

export const Route = createFileRoute('/_authenticated/_navbar/experiments')({
  validateSearch: searchSchema,
  search: {
    middlewares: [retainSearchParams(['sampleSetSearch'])],
  },
  component: Outlet,
});
